var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('full-bleed-layout',{staticClass:"home",attrs:{"show-leaderboard-ad":""}},[_c('not-found')],1)}
var staticRenderFns = []

export { render, staticRenderFns }